// frontend/src/api.js
import axios from 'axios';

// 优先使用构建时环境变量，其次使用运行时 window.__API_BASE__ 或当前站点域名
const runtimeBase = (typeof window !== 'undefined' && (window.__API_BASE__ || window.location.origin)) || '';
const BASE_URL = process.env.REACT_APP_API_BASE_URL || runtimeBase;

const api = axios.create({
    baseURL: BASE_URL, // 生产环境避免硬编码 localhost/IP
    withCredentials: true, // 如果后端需要发送 Cookie
    timeout: 12000, // 防止请求长期挂起
});

// 可供其他模块复用
export const API_BASE = BASE_URL;

console.log('[api] baseURL =', api.defaults.baseURL);

// 添加请求拦截器
api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 添加响应拦截器（可选，根据需要）
api.interceptors.response.use(
    response => response,
    error => {
        // 可以在这里统一处理错误，如重定向到登录页
        return Promise.reject(error);
    }
);

export default api;
